import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const setAllMembersToPlayingAtom = atom(null, (get, set) => {
  const booking = get(currentBookingAtom);

  if (!booking) return;

  const updatedBooking = {
    ...booking,
    rounds: booking.rounds.map((round: (typeof booking.rounds)[number]) => ({
      ...round,
      isNonPlayingHost: false,
    })),
  };

  set(currentBookingAtom, updatedBooking);
});
